import { getHighlightColumnSpans } from '@utils/event-report/get-highlight-column-spans';

export const HighlightSectionSkeletonContent = ({
  title,
  subtitle,
  cardCount = 6,
}: {
  title: string;
  subtitle?: string;
  cardCount?: number;
}) => (
  <>
    <h2 className='text-primary text-headline-l md:text-headline-xl px-4 mb-8 md:mb-10'>{title}</h2>
    {subtitle && (
      <div className='h-[22px] md:h-7 bg-tertiary w-32 rounded-sm px-4 mb-6 md:mb-8 mx-4 animate-pulse'></div>
    )}
    <div className='max-w-full overflow-x-auto scrollbar-hide gap-4 px-4 pb-0 flex md:grid md:grid-cols-12'>
      {getHighlightColumnSpans(cardCount).map((columnSpan, i) => (
        <div
          key={`highlight-card-${i}`}
          className={`p-4 basis-32 shrink-0 md:w-full ${columnSpan} bg-surface-secondary rounded-lg animate-pulse min-h-[146px] md:min-h-0`}>
          <div className='flex flex-col gap-2'>
            <div className='h-4 bg-tertiary w-20 rounded-sm'></div>
            <div className='h-6 bg-tertiary w-24 rounded-sm'></div>
            <div className='h-3 bg-tertiary w-16 rounded-sm'></div>
          </div>
        </div>
      ))}
    </div>
  </>
);
